import { ComponentProps, JSXElementConstructor } from 'react';
import { registerModals } from '@bonanza-social/navigation';
import AccountMFAModal from './AccountMFAModal';
import NotificationsModal from './NotificationsModal';

const modals = {
  TwoFactorAuthentication: AccountMFAModal,
  Notifications: NotificationsModal,
};

registerModals('account', modals);

declare global {
  interface RegisteredModals {
    account: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
